import Cookies from 'js-cookie'

const TokenKey = 'user_token'
const GuidKey = 'user_guid'
const CodeKey = 'user_code'
const UserInfoKey = 'user_info'

export function getToken() {
  return Cookies.get(TokenKey)
}

export function setToken(token) {
  return Cookies.set(TokenKey, token)
}

export function removeToken() {
  Cookies.remove(GuidKey)
  Cookies.remove(CodeKey)
  Cookies.remove(UserInfoKey)
  return Cookies.remove(TokenKey)
}
export function getGuid() {
  return Cookies.get(GuidKey)
}

export function setGuid(guid) {
  return Cookies.set(GuidKey, guid)
}
export function getCode() {
  return Cookies.get(CodeKey)
}

export function setCode(guid) {
  return Cookies.set(CodeKey, guid)
}


export function setUserInfo(data) {
  var userInfo = JSON.stringify(data)
  return Cookies.set(UserInfoKey, userInfo)
}
export function getUserInfo() {

  var jsonStr =  Cookies.get(UserInfoKey)

  if(jsonStr ){
    return JSON.parse(jsonStr);
  }
  else
  {
    return {}
  }
  
  //
  
}




